import { createConsumer } from "@rails/actioncable";

const cableUrl =
  import.meta.env.VITE_CABLE_URL ||
  (import.meta.env.DEV ? "ws://localhost:3000/cable" : "/cable");

export const cable = createConsumer(cableUrl);
